import React from 'react';
import styled from 'styled-components';

import { NavLink } from 'react-router-dom';

import playStore from '../../../assets/images/play-store-logo.png';
import facebookWhite from '../../../assets/images/facebook-white.png';
import instagramWhite from '../../../assets/images/instagram-white.png';
import twitterWhite from '../../../assets/images/twitter-white.png';
import youtubeWhite from '../../../assets/images/youtube-white.png';

import { mediaMax } from '../Media Template/Media Template';
import { Image, FlexContainer } from '../StyledComponents';

const goToURL = url => {
  window.open(url, '_blank');
};

const Footer = props => {
  const StyledFooter = styled.footer.attrs({
    className: 'pv4 ph3 ph4-m ph5-l'
  })`
    font-family: 'Nunito', sans-serif;
    background: #2c2c2c;
    border-top: 5px solid #4db2ec;
    color: #fff;
    width: 100%;
  `;

  const Links = styled.div.attrs({})`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    ${mediaMax.desktop`
    flex-direction: column;`};
  `;

  const StyledLinks = styled.div.attrs({
    className: 'tc mb5 ma2'
  })`
    display: inline-block;
    ${mediaMax.desktop`margin-top: 0; margin-bottom: 2rem;`};
  `;

  const StyledLink = styled.span.attrs({
    className: 'f4 dib ph2 link dim pointer'
  })`
    a {
      color: #fff;
      text-decoration: none;
    }
  `;

  const Copyright = styled.div.attrs({
    className: 'f6 db tc'
  })``;

  return (
    <StyledFooter className="Footer">
      {/* <FlexContainer
        className="w-100"
        style={{ height: '5px', background: '#4db2ec' }}
      /> */}
      <Links className="Links">
        <StyledLinks className="StyledLinks">
          <StyledLink>
            <NavLink to="/about" exact>
              About
            </NavLink>
          </StyledLink>
          <StyledLink>
            <NavLink to="/terms-and-conditions" exact>
              Terms and Conditions
            </NavLink>
          </StyledLink>
          <StyledLink>
            <NavLink to="/careers" exact>
              Careers
            </NavLink>
          </StyledLink>
          <StyledLink>
            <NavLink to="/FAQs" exact>
              FAQs
            </NavLink>
          </StyledLink>
          <StyledLink>
            <NavLink to="/advertise" exact>
              Advertise
            </NavLink>
          </StyledLink>
        </StyledLinks>
        <StyledLinks>
          <FlexContainer className="StyledLinks flex items-center">
            <Image
              className="pointer grow-large"
              src={playStore}
              onClick={() =>
                goToURL(
                  'https://play.google.com/store/apps/details?id=com.beebom.app.beebom&utm_source=app.beebom.com&utm_medium=website&utm_campaign=landing'
                )
              }
              width="112px"
              height="33px"
              margin="0 0.75rem"
              alt="Google play store logo"
            />
            <Image
              className="pointer grow-large"
              src={facebookWhite}
              onClick={() => goToURL('https://www.facebook.com/beebomco/')}
              width="13.3px"
              height="25.8px"
              margin="0 0.75rem"
              alt="Share on Facebook"
            />
            <Image
              className="pointer grow-large"
              src={instagramWhite}
              onClick={() => goToURL('https://www.instagram.com/beebomco/')}
              width="19px"
              height="20px"
              margin="0 0.75rem"
              alt="Share on Instagram"
            />
            <Image
              className="pointer grow-large"
              src={twitterWhite}
              onClick={() => goToURL('https://twitter.com/beebomco')}
              width="22px"
              height="18px"
              margin="0 0.75rem"
              alt="Share on Twitter"
            />
            <Image
              className="pointer grow-large"
              src={youtubeWhite}
              onClick={() => goToURL('https://www.youtube.com/beebomco')}
              width="22px"
              height="16px"
              margin="0 0.75rem"
              alt="Share on Youtube"
            />
          </FlexContainer>
        </StyledLinks>
      </Links>
      <Copyright className="Copyright">
        &copy;
        <b>Beebom Media Private Limited</b>,<span> All rights reserved</span>
      </Copyright>
    </StyledFooter>
  );
};

export default Footer;
